var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useRecipe } from "@chakra-ui/react";
import React from "react";
function SerpJobInner(_a, ref) {
    var children = _a.children, job = _a.job, onClickJob = _a.onClickJob, variant = _a.variant, rest = __rest(_a, ["children", "job", "onClickJob", "variant"]);
    var recipe = useRecipe({ key: "SerpJob" });
    var styles = recipe({ variant: variant });
    return (_jsx(Box, __assign({ role: "button", "aria-description": "Press to view job details", tabIndex: 0, css: styles, ref: ref, onClick: function (e) {
            if (e.target.tagName.toLowerCase() !== "a" && onClickJob) {
                onClickJob(job);
            }
        }, onKeyDown: function (e) {
            if (e.key == "Enter") {
                onClickJob(job);
            }
        }, "data-jobkey": job.jobKey }, rest, { children: children })));
}
/**
 * Renders a SerpJob component. This component should be used when overriding the SerpJob component.
 * It wraps the SerpJob content in an appropriate tag with click handler, data attributes, and classnames.
 */
export var SerpJob = React.forwardRef(SerpJobInner);
